/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Card, Row, Col, CardBody, Button, CardTitle, Input, Badge, InputGroup, Container, Modal, ModalHeader, ModalBody, Carousel, CarouselItem, CarouselControl, CarouselIndicators } from 'reactstrap';
import axios from 'axios';
// import GoogleMapReact from 'google-map-react';
import "./Style.css";
import MobileHeader from 'components/Headers/MobileHeader';

const AbsensiStaff = () => {
  const token = localStorage.token;
  const userid = localStorage.uic;
  const unit = localStorage.u;
  const username = localStorage.username;
  // const [long, setLong] = useState(null);
  // const [lat, setLat] = useState(null);
  // const [iconout, setIconOut] = useState("");
  const [buttoncekin, setButtonCekIn] = useState("");
  const [buttoncekout, setButtonCekOut] = useState("");
  const [clockin, setClockIn] = useState("");
  const [clockout, setClockOut] = useState("");
  const [modal6, setModal6] = useState(false);
  const toggless = () => setModal6(!modal6);
  const [name, setName] = useState("");
  const [picture, setPicture] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [salary, setSalary] = useState(null);
  const [passwordShown, setPasswordShown] = useState(false);
  const [buttonIstirahat, setButtonIstirahat] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const items = [
    {
      src: 'https://i.imgur.com/HoeWKZ9.jpeg',
      altText: 'Absen',
      title: 'Absensi'
    },
    {
      src: 'https://i.imgur.com/ugaWS91.jpeg',
      altText: 'Cuti',
      title: 'Izin Cuti'
    },
    {
      src: 'https://i.imgur.com/MF3Ulir.jpeg',
      altText: 'Dinas',
      title: 'Izin Dinas'
    }
  ];

  // Fungsi next untuk beralih ke slide berikutnya
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  // Autoplay: Mengubah slide secara otomatis setiap 3 detik
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 5000); // Mengganti slide setiap 3 detik

    return () => {
      clearInterval(interval); // Membersihkan interval saat komponen unmount
    };
  }, [activeIndex, animating]);

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <Row className="justify-content-center px-1">
          <Col xs="12" sm="10" md="8">
            <CardBody className="p-4">
              <div className="text-center">
                <img
                  src={item.src}
                  alt={item.altText}
                  className="img-fluid rounded shadow-sm"
                  style={{
                    maxHeight: "400px",
                    borderRadius: "16px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </CardBody>
            {/* </Card> */}
          </Col>
        </Row>
      </CarouselItem>

    );
  });

  const formatRupiah = (money) => {
    return new Intl.NumberFormat('id-ID',
      { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
    ).format(money);
  }

  const ButtonMasukCok = async () => { window.location.href = "/mobile/staff-absen/masuk" };
  const ButtonKeluarCok = async () => { window.location.href = "/mobile/staff-absen/pulang" };
  const ButtonCuti = async () => { window.location.href = "/mobile/dispensasi-karyawan/izin" };
  const ButtonDinas = async () => { window.location.href = "/mobile/dinas/page" };
  const ButtonKehadiran = async () => { window.location.href = "/mobile/kehadiran/page" };
  const ButtonSales = async () => { window.location.href = "/mobile/sales/page" };
  const ButtonPettyCash = async () => { window.location.href = "/mobile/pettycash/page" };
  const ButtonKasbon = async () => { window.location.href = "/mobile/kasbon/page" };
  const ButtonIstirahat = async () => { window.location.href = "/mobile/istirahat/page" };

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const successCallback = (position) => {
  };

  const errorCallback = (error) => {
  };

  navigator.geolocation.getCurrentPosition(successCallback, errorCallback);

  useEffect(() => {
    cekLongitude()
    setInterval(() => {
      cekLongitude()
    }, 5000);
    getByUser()
  }, [])

  const cekLongitude = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        getJamdanButton(latitude, longitude);
      },
      (err) => {
        console.error("Gagal mendapatkan lokasi", err);
      }
    );
  };

  const getJamdanButton = (lat, long) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const data = {
      username: username,
      latitude: lat,
      longitude: long,
    };

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/absensi-karyawan/get-by-username`, data, { headers })
      .then((data) => {
        setButtonIstirahat(data.data.response.status_break);
        setButtonCekIn(data.data.response.check_in);
        setButtonCekOut(data.data.response.check_out);
        setClockIn(data.data.response.clock_in);
        setClockOut(data.data.response.clock_out);
        localStorage.setItem("ai", data.data.response.absensi_karyawan_id);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getByUser = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/users/profil/${userid}`,
        { headers }
      )
      .then((data) => {
        setName(data.data.response.name);
        setPicture(data.data.response.karyawan_image);
        setJabatan(data.data.response.jabatan);
        setSalary(data.data.response.gaji);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div>
      <MobileHeader name={name} picture={picture} jabatan={jabatan} />
      <Container className="mt--5" fluid>
        <Row>
          <div className="col">
            <Card
              className="shadow-sm border-0 p-3 mb-3"
              style={{ borderRadius: "20px", backgroundColor: "#ffffff" }}
            >
              <Row className="align-items-center text-center">
                {/* Kolom Masuk */}
                <Col xs="5" className="text-start">
                  <CardTitle
                    tag="h6"
                    className="text-uppercase text-muted mb-1 fw-semibold"
                    style={{ fontSize: "0.7rem", fontWeight: 1000 }}
                  >
                    Masuk
                  </CardTitle>
                  <h5>
                    <Badge color="info" pill style={{ fontSize: "0.7rem", fontWeight: 1000 }}>
                      {clockin || "--:--"}
                    </Badge>
                  </h5>
                </Col>

                {/* Ikon Tengah */}
                <Col xs="2" className="d-flex justify-content-center">
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // backgroundColor: "#f1f3f5",
                      // boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <i
                      className="fas fa-clock fa-3x"
                      style={{
                        color: "#6c757d",
                        opacity: 0.4, // Semakin kecil, semakin transparan
                      }}
                    />
                  </div>
                </Col>
                {/* Kolom Pulang */}
                <Col xs="5" className="text-end">
                  <CardTitle
                    tag="h6"
                    className="text-uppercase text-muted mb-1 fw-semibold"
                    style={{ fontSize: "0.7rem", fontWeight: 1000 }}
                  >
                    Pulang
                  </CardTitle>
                  <h5>
                    <Badge color="danger" pill style={{ fontSize: "0.7rem", fontWeight: 1000 }}>
                      {clockout || "--:--"}
                    </Badge>
                  </h5>
                </Col>
              </Row>
            </Card>


            {/* </Card> */}
            <div className='mt-4'></div>
            {/* <CardBody></CardBody> */}
            <Row className="mt-3 g-2">
              {[
                { title: "Cuti", img: "cuti.png", action: ButtonCuti },
                { title: "Dinas", img: "dinas.png", action: ButtonDinas },
                { title: "Kehadiran", img: "kehadiran.png", action: ButtonKehadiran },
                { title: "Gaji", img: "gaji.png", action: toggless },
                { title: "PettyCash", img: "pettycash.png", action: ButtonPettyCash },
                { title: "Kasbon", img: "logohokkydana.png", action: ButtonKasbon },
                // { title: "Sales", img: "sales.png", action: ButtonSales },
                ...(unit === "Sales" || unit === "Canvaser" ? [{ title: "Sales", img: "canvaser.png", action: ButtonSales }] : []),
                ...(buttoncekout === 1 && buttonIstirahat === 1 || buttoncekout === 1 && buttonIstirahat === 2 || buttoncekout === 1 && buttonIstirahat === 3 || buttoncekout === 1 && buttonIstirahat === 4 || buttoncekout === 1 && buttonIstirahat === 5 ? [{ title: "Istirahat", img: "istirahat.png", action: ButtonIstirahat }] : []),
              ].map((menu, i) => (
                <Col key={i} xs="3" className="text-center">
                  {/* <div onClick={menu.action} style={{ cursor: 'pointer' }}> */}
                  <div
                    onClick={(e) => {
                      const el = e.currentTarget.querySelector(".icon-box");
                      el.classList.remove("bounce");
                      void el.offsetWidth; // Force reflow
                      el.classList.add("bounce");
                      menu.action(); // jalankan aksi
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className="icon-box"
                      style={{
                        backgroundColor: "#e6f7ff",
                        borderRadius: 15,
                        width: 70,
                        height: 70,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 auto",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        transition: "transform 0.2s ease"
                      }}
                    >
                      <img
                        alt={menu.title}
                        src={require(`assets/img/theme/${menu.img}`).default}
                        style={{ width: 60, height: 60 }}
                      />
                    </div>
                    <small className="mt-3 d-block"></small>
                  </div>
                </Col>
              ))}
            </Row>
            <div>
              <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
                {slides}
              </Carousel>
            </div>
            <br></br>
            <Row xs="1">
              <Col>
                <Card className="card-stats mb-0 mb-xl-2">
                  <CardBody>
                    <Row>
                      <div className='col ml--2'>
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          <b>Informasi Gaji</b> &nbsp;
                          {passwordShown !== true ? (
                            <i className="fa fa-eye" aria-hidden="true" onClick={togglePasswordVisiblity} />
                          ) : (
                            <i className="fa fa-eye-slash" aria-hidden="true" onClick={togglePasswordVisiblity} />
                          )}
                        </CardTitle>
                        <InputGroup>
                          <Input
                            bsSize="sm"
                            style={{ fontSize: "17px", fontFamily: 'Tahoma', fontWeight: 'bold' }}
                            plaintext
                            type={passwordShown ? "text" : "password"}
                            value={formatRupiah(salary)}
                            onChange={(e) => {
                              setSalary(e.target.value);
                            }}
                          />
                        </InputGroup>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-wallet"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row xs="1">
              <Col>
                <Card className="card-stats mb-0 mb-xl-2">
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row xs="1">
              <Col>
                <Card className="card-stats mb-0 mb-xl-2">
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row xs="1">
              <Col>
                <Card className="card-stats mb-0 mb-xl-2">
                </Card>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>
      <Modal isOpen={modal6} toggle={toggless}>
        <ModalHeader toggle={toggless} align="center"></ModalHeader>
        <ModalBody align="center">
          <font size="5"><b>Segera Hadir</b></font><br /><br />
          <i className="fa fa-cog fa-5x fa-spin" aria-hidden="true"></i><br /><br />
          <Button color="secondary" onClick={toggless}>
            Cancel
          </Button>
        </ModalBody>
      </Modal>
      <nav className="navbar bg-white navbar-expand fixed-bottom d-md-none d-lg-none d-xl-none">
        <ul className="navbar-nav nav-justified w-100">
          <li className="nav-item">
            <a href="/mobile/staff-absen" className="nav-link text-center">
              <i className="fas fa-home fa-lg d-block mb-1" />
              <span className="small">Home</span>
            </a>
          </li>
          <li className="nav-item">
            <div className='btn-links' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 12,
                  height: 90,
                  width: 90,
                  position: `absolute`,
                  backgroundColor: "white",
                  borderRadius: "50%",
                }}
              >
                <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: "#fab005" }}></i>
              </div>
              {buttoncekin === 2 && buttoncekout === 2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: 10,
                    height: 80,
                    width: 80,
                    position: `absolute`,
                    borderRadius: "50%",
                  }}
                  className="btn btn-warning"

                >
                  <i className="fa fa-times fa-3x" />
                </div>
              )}
              {buttoncekin && buttoncekin === 1 && (
                <Button style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 10,
                  height: 80,
                  width: 80,
                  position: `absolute`,
                  borderRadius: "50%",
                }} color="info" onClick={ButtonMasukCok}>
                  <i className="fas fa-sign-in-alt fa-3x" />
                </Button>
              )}
              {buttoncekout && buttoncekout === 1 && buttonIstirahat === 2 || buttoncekout && buttoncekout === 1 && buttonIstirahat === 3 || buttoncekout && buttoncekout === 1 && buttonIstirahat === 4 || buttoncekout && buttoncekout === 1 && buttonIstirahat === 5 || buttoncekout && buttoncekout === 1 && buttonIstirahat === 0 ? (
                <Button style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 10,
                  height: 80,
                  width: 80,
                  position: `absolute`,
                  borderRadius: "50%",
                }} color="danger" onClick={ButtonKeluarCok}>
                  <i className="fas fa-sign-out-alt fa-3x" />
                </Button>
              ) : (
                ""
              )}
            </div>
          </li>
          <li className="nav-item">
            <a href="/mobile/profile" className="nav-link text-center">
              <i className="fas fa-user fa-lg d-block mb-1" />
              <span className="small">Akun</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default AbsensiStaff;